<p>
  info-modal-image works!
</p>
